"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NotificationItem = exports.Icon = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _Viewer = babelHelpers.interopRequireDefault(require("./Viewer"));

var _Listener = babelHelpers.interopRequireDefault(require("./Listener"));

var _type = babelHelpers.interopRequireDefault(require("./type.noNotifications"));

var _locations = babelHelpers.interopRequireDefault(require("locations"));

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _class, _descriptor, _descriptor2, _temp, _class3, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _class4, _temp2, _class5, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _temp3, _class7, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _temp4;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var FillerNode = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(FillerNode, _Component);

  function FillerNode() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, FillerNode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(FillerNode)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "item", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "onSelected", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(FillerNode, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(NotificationItem, {
        item: this.item,
        onSelected: this.onSelected
      }, "Unknown notification type: ", this.item.type, _react.default.createElement("br", null), this.props.error.stack);
    }
  }]);
  return FillerNode;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "onSelected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
var Icon = (_class3 = (_temp2 = _class4 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(Icon, _Component2);

  function Icon() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, Icon);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(Icon)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "type", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "value", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "overlay", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "overlayType", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "link", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(Icon, [{
    key: "getImageSource",
    value: function getImageSource(src) {
      if (Icon.email) {
        if (src.startsWith('/t')) {
          var s = src.split('/');
          var start = s.indexOf('f');
          var end = s.length - 1;

          if (start != -1 && end > start) {
            s = s.slice(start + 1, end);
            src = "/".concat(s.join('/'));
          }
        }

        return "/t/square/width=55/height=55/scale/f".concat(src, "/icon.png");
      }

      return src;
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "notification-icon"
      }, this.type == 'material' && (Icon.email && this.link ? _react.default.createElement("a", {
        className: "primary-icon material-icons",
        "data-icon": this.value,
        href: this.link
      }) : _react.default.createElement("div", {
        className: "primary-icon material-icons",
        "data-icon": this.value
      })), !Icon.email && this.type == 'image' && _react.default.createElement("div", {
        className: "primary-icon image",
        style: {
          backgroundImage: "url(".concat(this.value, ")")
        }
      }), Icon.email && this.type == 'image' && (this.link ? _react.default.createElement("a", {
        className: "primary-icon image",
        href: this.link
      }, _react.default.createElement("img", {
        src: this.getImageSource(this.value)
      })) : _react.default.createElement("img", {
        className: "primary-icon image",
        src: this.getImageSource(this.value)
      })), this.type == 'text' && (Icon.email ? this.link ? _react.default.createElement("div", {
        className: "primary-icon text"
      }, _react.default.createElement("a", {
        href: this.link
      }, this.value)) : _react.default.createElement("div", {
        className: "primary-icon text"
      }, this.value) : _react.default.createElement(_ProfileImageContainer.default, {
        literal: true,
        className: "primary-icon text",
        noImageClassName: "",
        name: this.value
      })), !Icon.email && this.overlay && _react.default.createElement("span", {
        className: "overlay-icon material-icons",
        "data-overlay-type": this.overlayType,
        "data-icon": this.overlay
      }));
    }
  }]);
  return Icon;
}(_react.Component), _class4.email = false, _temp2), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "type", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "value", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "overlay", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "overlayType", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "link", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.Icon = Icon;
var NotificationItem = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(NotificationItem, _Component3);

  function NotificationItem() {
    var _babelHelpers$getProt3;

    var _this3;

    babelHelpers.classCallCheck(this, NotificationItem);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(NotificationItem)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "item", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "onSelected", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "selected", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "asLink", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "overlay", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "overlayType", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    return _this3;
  }

  babelHelpers.createClass(NotificationItem, [{
    key: "render",
    value: function render() {
      var Outer, props;

      if (NotificationItem.makeLinkTarget) {
        var _NotificationItem$mak = NotificationItem.makeLinkTarget(this.item),
            Outer = _NotificationItem$mak.Outer,
            props = _NotificationItem$mak.props;
      } else if (this.asLink) {
        Outer = 'a';
        props = {
          href: (0, _locations.default)(this.item.linkTarget || 'javascript:void(0)')
        };
      } else {
        Outer = 'div';
        props = {};
      }

      var Link = Outer;
      var LinkProps = props;

      if (Icon.email) {
        Outer = 'div';
        props = {};
      }

      return _react.default.createElement(Outer, _extends({}, props, {
        "data-notification-type": this.item.type,
        onClick: this.selectNotification,
        className: _classList.default.join('notification-item', this.item.isNew ? 'new-notification-item' : '', this.selected ? 'selected' : null)
      }), this.item.picture && _react.default.createElement(Icon, _extends({}, this.item.picture, {
        overlay: this.overlay,
        overlayType: this.overlayType,
        link: props.href
      })), _react.default.createElement("div", {
        className: "notification-body"
      }, _react.default.createElement("div", {
        className: "body-content"
      }, Icon.email ? _react.default.createElement(Link, LinkProps, this.props.children) : this.props.children), this.item.time ? _react.default.createElement("time", {
        dateTime: this.item.time,
        className: "notification-date"
      }, false && Icon.email && this.overlay ? _react.default.createElement("span", {
        className: "type-icon material-icons",
        "data-overlay-type": this.overlayType,
        "data-icon": this.overlay
      }) : null, this.formatDate()) : null));
    }
  }, {
    key: "formatDate",
    value: function formatDate() {
      var d = new Date(this.item.time),
          now = Date.now();

      if (NotificationItem.forceDateFormat) {
        return d.format(NotificationItem.forceDateFormat);
      }

      if (d.getTime() > now - 60000) {
        return 'now';
      }

      if (d.getTime() > now - 3600000) {
        var minutes = (now - d.getTime()) / 60000;
        minutes = Math.round(minutes);
        return "".concat(minutes, " minute").concat(minutes == 1 ? '' : 's', " ago");
      }

      if (d.getTime() > now - 86400000) {
        var hours = (now - d.getTime()) / 3600000;
        hours = Math.floor(hours);
        return "".concat(hours, " hour").concat(hours == 1 ? '' : 's', " ago");
      }

      if (d.getTime() > now - 7 * 86400000) {
        var days = (now - d.getTime()) / 86400000;
        days = Math.floor(days);
        return "".concat(days, " day").concat(days == 1 ? '' : 's', " ago");
      }

      if (d.getTime() > now - 365 * 86400000) {
        return d.format('M j');
      }

      return d.format('M j, Y');
    }
  }, {
    key: "selectNotification",
    value: function selectNotification(event) {
      event.preventDefault();
      this.onSelected(this.item, event.shiftKey);
    }
  }], [{
    key: "notificationObject",
    value: function notificationObject(_ref) {
      var item = _ref.item;
      return new Promise(function (resolve) {
        resolve({
          icon: item.picture && item.picture.type == 'image' ? item.picture.value : null,
          tag: item.id,
          data: {
            url: item.linkTarget || null
          }
        });
      });
    }
  }]);
  return NotificationItem;
}(_react.Component), _temp3), (_descriptor8 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "onSelected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "selected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "asLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "overlay", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "overlayType", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "selectNotification", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "selectNotification"), _class5.prototype)), _class5);
exports.NotificationItem = NotificationItem;
var EmptyNodeData = {
  type: 'noNotifications',
  id: 'noNotifications',
  isNew: false,
  isSeen: true,
  time: null
};
var NotificationList = (_class7 = (_temp4 =
/*#__PURE__*/
function (_Component4) {
  babelHelpers.inherits(NotificationList, _Component4);

  function NotificationList() {
    var _babelHelpers$getProt4;

    var _this4;

    babelHelpers.classCallCheck(this, NotificationList);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this4 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt4 = babelHelpers.getPrototypeOf(NotificationList)).call.apply(_babelHelpers$getProt4, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this4, "limit", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "closePanel", _descriptor15, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "notifications", _descriptor16, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "open", _descriptor17, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "onSelected", _descriptor18, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "initialSelected", _descriptor19, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "hasMore", _descriptor20, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "showMore", _descriptor21, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    _this4.state = {
      limit: null,
      selectedItem: _this4.initialSelected
    };
    _this4.state.limit = _this4.limit;
    _this4.notificationViewer = new _Viewer.default();

    _this4.notificationViewer.setNotifications(_this4.notifications, _this4.state.selectedItem);

    return _this4;
  }

  babelHelpers.createClass(NotificationList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this.notificationViewer.setNotifications(this.notifications, this.state.selectedItem);

      if (this.open) {
        _Listener.default.markAllRead();
        /*
        var nf = this.notifications.feed.filter(item => !item.isSeen);
        notificationListener.markSeen(nf.map(item => item.id))
        */


        if (prevProps.open != this.open && this.closePanel) document.addEventListener('click', this.clickOnDocument);
      } else {
        if (prevProps.open != this.open && this.closePanel) document.removeEventListener('click', this.clickOnDocument);
      }

      if (prevProps.initialSelected != this.props.initialSelected) {
        this.setState({
          selectedItem: this.props.initialSelected
        });
      }
    }
  }, {
    key: "feed",
    value: function feed() {
      if (this.state.limit === false) return this.notifications.feed || [];
      return (this.notifications.feed || []).slice(0, this.state.limit);
    }
  }, {
    key: "markAllRead",
    value: function markAllRead() {
      _Listener.default.markAllRead();
    }
  }, {
    key: "gotRoot",
    value: function gotRoot(node) {
      this.rootNode = node;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.open && this.closePanel) {
        document.addEventListener('click', this.clickOnDocument);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.open && this.closePanel) {
        document.removeEventListener('click', this.clickOnDocument);
      }
    }
  }, {
    key: "clickOnDocument",
    value: function clickOnDocument(event) {
      if (this.rootNode && this.open) {
        var t = event.target;

        do {
          if (t == this.rootNode) return;
          t = t.parentNode;
        } while (t && t != document.documentElement);

        if (this.closePanel) {
          this.closePanel();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return _react.default.createElement("section", {
        className: _classList.default.join('notification-list', this.open ? 'open' : '', this.open === false ? 'closed' : ''),
        ref: this.gotRoot
      }, _react.default.createElement("header", null, _react.default.createElement("h4", null, "Notifications"), false && this.feed().length < (this.notifications.feed || []).length && _react.default.createElement("a", {
        className: "view-more-item",
        href: "javascript:void(0)",
        onClick: this.viewMore
      }, "View more"), !Icon.email && !!this.feed().filter(function (v) {
        return v.isNew;
      }).length && _react.default.createElement("a", {
        href: "javascript:void(0)",
        className: "mark-all-read",
        onClick: this.markAllRead
      }, "Mark all as read"), Icon.email && this.props.daily ? _react.default.createElement("h4", {
        className: "date-header"
      }, new Date(this.feed()[0].time).format('M j')) : null), _react.default.createElement("div", {
        className: "notification-list-content"
      }, this.feed().map(function (item) {
        try {
          var Node = require("components/Notifications/type.".concat(item.type)).default;

          return _react.default.createElement(Node, {
            item: item,
            selected: item.id == _this5.state.selectedItem,
            key: item.id,
            onSelected: _this5.selectedItem
          });
        } catch (e) {
          return _react.default.createElement(FillerNode, {
            item: item,
            error: e,
            selected: item.id == _this5.state.selectedItem,
            key: item.id,
            onSelected: _this5.selectedItem
          });
        }
      }), this.feed().length == 0 && _react.default.createElement(_type.default, {
        item: EmptyNodeData,
        selected: false,
        key: EmptyNodeData.id,
        onSelected: this.selectedItem
      }), this.feed().length < (this.notifications.feed || []).length && _react.default.createElement("a", {
        className: "view-more-item",
        href: "javascript:void(0)",
        onClick: this.viewMore
      }, "View more"), this.feed().length == (this.notifications.feed || []).length && this.hasMore && _react.default.createElement("a", {
        className: "view-more-item",
        href: "javascript:void(0)",
        onClick: this.showMore
      }, "View more")));
    }
  }, {
    key: "viewMore",
    value: function viewMore(event) {
      event.preventDefault();
      this.setState(function (state) {
        return {
          limit: state.limit + 10
        };
      });
    }
  }, {
    key: "selectedItem",
    value: function selectedItem(item, inModal) {
      var _this6 = this;

      if (this.closePanel) this.closePanel();
      if (item === EmptyNodeData) return;
      (item.id.startsWith('grading:') ? Promise.resolve(true) : _Listener.default.markRead(item.id)).then(function () {
        if (_this6.onSelected) {
          if (_this6.onSelected(item)) {
            _this6.setState({
              selectedItem: item.id
            });
          }
        } else {
          if (!inModal && item.linkTarget) {
            location.href = (0, _locations.default)(item.linkTarget);
          } else {
            _this6.setState({
              selectedItem: item.id
            }, function () {
              this.notificationViewer.show();
            });
          }
        }
      });
    }
  }]);
  return NotificationList;
}(_react.Component), _temp4), (_descriptor14 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "limit", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "closePanel", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor16 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "notifications", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "open", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor18 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "onSelected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "initialSelected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor20 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "hasMore", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor21 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "showMore", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "markAllRead", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "markAllRead"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "gotRoot", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "gotRoot"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "clickOnDocument", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "clickOnDocument"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "viewMore", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "viewMore"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "selectedItem", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "selectedItem"), _class7.prototype)), _class7);
exports.default = NotificationList;